import Typography, { TypographyProps } from '@mui/material/Typography'

export default function Code({ children, ...props }: TypographyProps) {
  return (
    <Typography {...props} variant="code" sx={{ ...props.sx, wordBreak: 'break-all' }}>
      {children}
    </Typography>
  )
}
